import { useQuery } from '@tanstack/react-query'
import { getAvailableRecipes } from './recipesApi'

export const useRecipes = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['recipes'],
        queryFn: getAvailableRecipes,
    })

    return {
        recipes: data?.recipes || [],
        isLoading,
    }
}
